import { type Message, type MessageProducer } from './types';

export type CreateMessageProducerOptions = {
  targetOrigin?: string;
  targetWindow: Window | null;
};

export const createMessageProducer = <TargetMessage extends Message<string>>({
  targetOrigin = '*',
  targetWindow,
}: CreateMessageProducerOptions): MessageProducer<TargetMessage> => {
  return {
    sendMessage: <T extends TargetMessage['type']>(message: Extract<TargetMessage, { type: T }>) => {
      targetWindow?.postMessage(message, targetOrigin);
    },
  };
};
